import { Label, Tab, TableRow } from "@mcleod/components";
import { Api } from "@mcleod/core";
import { AutogenLayoutEdiFuncAckSeg } from "./autogen/AutogenLayoutEdiFuncAckSeg";

export class EdiFuncAckSeg extends AutogenLayoutEdiFuncAckSeg {
    private _faId: string;
    private _version: string;

    public get version(): string {
        return this._version;
    }

    public set version(value: string) {
        this._version = value;
    }

    public get faId(): string {
        return this._faId;
    }
    public set faId(value: string) {
        this._faId = value;
    }

    override onLoad(): void {

        this.styleTab(this.tabFASegment);
    }

    async tableFASegOnRowDisplay(event) {
        const tableRow: TableRow = event.getTableRow();
        const funcSegRow = tableRow.data.data;
        const labelSegError = (tableRow.findComponentById("labelSegmentError")) as Label
        const code = funcSegRow["segment_error_code"];
        if (code) {
            await Api.search("lme/datafusion/standard-code", {
                "version": this.version, "element_id": "720", "standard_code": code
            }).then((response) => {
                const standardCodeRow = response.data[0];
                if (standardCodeRow != undefined) {
                    labelSegError.text = standardCodeRow["description"];
                }
            });
        }

        const labelElementError = (tableRow.findComponentById("labelElementError")) as Label
        const elementCode = funcSegRow["error_number"];
        if (elementCode) {
            await Api.search("lme/datafusion/standard-code", {
                "version": this.version, "element_id": "723", "standard_code": elementCode
            }).then((response) => {
                const standardCodeRow = response.data[0];
                if (standardCodeRow != undefined) {
                    labelElementError.text = standardCodeRow["description"];
                }
            });
        }
    }

    sourceEdiFunctionalSegAfterExecution() {
        this.tabFASegment["countLabel"].text = this.sourceEdiFunctionalSeg.data.length;
    }

    styleTab(tab: Tab) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = "subtle.light";
            tab.headingLabel.setProps({ color: "default", fontBold: true, fillRow: false })
            if (tab["countLabel"] == null) {
                tab["countLabel"] = new Label({
                    fontBold: true, text: "0", fillRow: true,
                    color: "primary", rowBreak: false, marginLeft: 5
                });
                tab.heading.insert(tab["countLabel"], 1);
            }
        }
    }
}
